import { useState } from "react";
import LandingTopbar from "../components/sections/LandingTopbar";
import Input from "../components/ui/InputForm";
import Checkbox from "../components/ui/Checkbox";
import Button from "../components/ui/Button";
import { apiFetch } from "../api/client";
import "./Contact.css";

const initialForm = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  message: "",
  demo: false,
  quote: false,
  loginHelp: false,
};

function Contact() {
  const [form, setForm] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheck = (name) => (e) => {
    const { checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await apiFetch("/api/contact/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        const errorPayload = await response.json().catch(() => ({}));
        const errorMessage =
          errorPayload?.detail ||
          "Versturen mislukt. Probeer het opnieuw.";
        setSubmitStatus({ type: "error", message: errorMessage });
        return;
      }

      setSubmitStatus({
        type: "success",
        message: "Bedankt! We nemen zo snel mogelijk contact met je op.",
      });
      setForm(initialForm);
    } catch (error) {
      console.error("Contact submit failed:", error);
      setSubmitStatus({
        type: "error",
        message: "Er ging iets mis. Controleer je verbinding en probeer het opnieuw.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <LandingTopbar />
      <div className="contact-body">
        <div className="contact-left">
          <div className="contact-copy">
            <h1 className="contact-title">We maken graag kennis, Laten we in contact komen!</h1>
            <p className="contact-subtitle">
              Je kan ons altijd bereiken door te mailen naar{" "}
              <a href="mailto:continuemee@kurtosis.nl">continuemee@kurtosis.nl</a>
            </p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-row">
              <Input
                label="Voornaam *"
                name="firstName"
                placeholder="Voornaam"
                value={form.firstName}
                onChange={handleChange}
                required
                wrapperClassName="contact-input"
              />
              <Input
                label="Achternaam *"
                name="lastName"
                placeholder="Achternaam"
                value={form.lastName}
                onChange={handleChange}
                required
                wrapperClassName="contact-input"
              />
            </div>

            <Input
              label="Email *"
              name="email"
              type="email"
              placeholder="E-mailadres"
              value={form.email}
              onChange={handleChange}
              required
            />

            <Input
              label="Telefoonnummer"
              name="phone"
              placeholder="+31 6 123 456 78"
              value={form.phone}
              onChange={handleChange}
            />

            <Input
              label="Bericht *"
              name="message"
              type="textarea"
              placeholder="Wat wil je ons vertellen..."
              value={form.message}
              onChange={handleChange}
              required
              inputClassName="contact-textarea"
            />

            <div className="contact-checks">
              <p className="contact-checks-label">Dienstverlening</p>
              <Checkbox
                label="Ik wil een demo"
                name="demo"
                checked={form.demo}
                onChange={handleCheck("demo")}
              />
              <Checkbox
                label="Ik wil een prijsopgave"
                name="quote"
                checked={form.quote}
                onChange={handleCheck("quote")}
              />
              <Checkbox
                label="Inloggen lukt niet"
                name="loginHelp"
                checked={form.loginHelp}
                onChange={handleCheck("loginHelp")}
              />
            </div>

            {submitStatus && (
              <div className={`contact-status ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}

            <Button type="submit" variant="primary" fullWidth disabled={isSubmitting}>
              {isSubmitting ? "Bezig met verzenden..." : "Verstuur"}
            </Button>
          </form>
        </div>

        <div className="contact-right" aria-hidden="true">
          <img src="/ipad-lady.png" alt="" />
        </div>
      </div>
    </div>
  );
}

export default Contact;
